import { PermissionSchema } from './types';

export const getPermissionIdsByKeys = (
  permissions: PermissionSchema[],
  keys: string[],
) => {
  const ids = permissions
    .filter((permission) => keys.includes(permission.key))
    .map((permission) => permission.id);
  return [...new Set(ids)];
};

export const getPermissionsByKeys = (
  permissions: PermissionSchema[],
  keys: string[],
) => {
  const filtered = permissions.filter((permission) =>
    keys.includes(permission.key),
  );
  return [...new Map(filtered.map((p) => [p.id, p])).values()];
};
